<template>
  <tr>
    <th>
      전송 시간
      <span class="required">*</span>
    </th>
    <td>
      <input type="radio" :id="`direct_${uuid}`" :name="`send_${uuid}`" value="DIRECT" v-model="pushType_local" />
      <label :for="`direct_${uuid}`" class="marR_20">즉시 전송</label>
      <input type="radio" :id="`reserve_${uuid}`" :name="`send_${uuid}`" value="RESERVE" v-model="pushType_local" />
      <label :for="`reserve_${uuid}`">예약 전송</label>

      <template v-if="pushType_local === 'RESERVE'">
        <DateTimePicker
          :value="reserveDate_local"
          :minDate="reserveMinDate"
          :maxDate="reserveMaxDate"
          displayTime="00:00~23:30"
          defaultTime="09:00"
          @change="onChangeDateTimePicker"
          ref="reserveDatePicker"
        />
        <p class="caution"><span class="ico">*</span> 받는 사람수에 따라 지정한 시간에서 10분 내외의 delay가 발생할 수 있습니다.</p>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    pushType: {
      type: String,
      default: 'DIRECT',
    },
    reserveDate: {
      type: [String, Date],
      default() {
        const result = new Date();
        result.setHours(9, 0, 0, 0);
        result.setDate(result.getDate() + 1);
        return result;
      },
    },
    reserveMinDate: {
      type: Date,
      default: () => new Date(),
    },
    reserveMaxDate: {
      type: Date,
      default() {
        const result = new Date();
        result.setHours(23, 30, 0, 0);
        result.setDate(result.getDate() + 6);
        return result;
      },
    },
  },
  data() {
    let reserveDate_local = new Date(this.reserveDate);
    if (reserveDate_local < this.reserveMinDate) reserveDate_local = new Date(this.reserveMinDate);
    return {
      pushType_local: this.pushType,
      reserveDate_local,
    };
  },
  watch: {
    pushType_local(val) {
      this.$emit('update:pushType', val);
    },
    reserveDate_local(val) {
      this.$emit('update:reserveDate', val);
    },
  },
  methods: {
    validate() {
      switch (this.pushType) {
        // case 'DIRECT':
        //   const currentHours = new Date().getHours();
        //   if (currentHours < 8 || currentHours >= 20) {
        //     alert('오후 8시에서 오전 8시 까지는\n예약전송만 가능합니다.');
        //     return false;
        //   }
        //   break;
        case 'RESERVE':
          if (!this.reserveDate) {
            alert('예약전송 하시려면 날짜와 시간을 선택해 주세요.');
            return false;
          }
          break;
      }
      return true;
    },
    onChangeDateTimePicker(date) {
      this.reserveDate_local = date;
    },
  },
  mounted() {
    this.$emit('update:pushType', this.pushType_local);
    this.$emit('update:reserveDate', this.reserveDate_local);
  },
};
</script>

<style></style>
